import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../shared/auth/auth.service';
import { NavigationService } from '../shared/auth/navigation.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private navigationService = inject(NavigationService);

  userRole = '';
  isApproved = true;

  ngOnInit() {
    const currentUser = this.authService.getCurrentUser();
    if (currentUser) {
      this.userRole = currentUser.role;
      this.isApproved = currentUser.isApproved;
    }
  }

  goToDefaultPage() {
    const currentUser = this.authService.getCurrentUser();
    if (currentUser) {
      const defaultRoute = this.navigationService.getDefaultRouteForRole(currentUser.role);
      this.router.navigate([defaultRoute]);
    } else {
      this.router.navigate(['/login']);
    }
  }

  goBack() {
    window.history.back();
  }

  logout() {
    this.authService.logout();
  }
}